<template>
  <div>
    <page-header></page-header>

    <section>
      <div class="container">
        <div class="columns we-connect" style="width: 100%;">
          <div class="column is-5 is-offset-1">
            <h1 class="title is-1 custom-h1">We connect</h1>
            <h1 class="title is-1 custom-h1 has-text-danger">
              <span
                 class="txt-rotate"
                 data-period="2000"
                 data-rotate='[ "Places", "Hotels", "People" ]'></span>
            </h1>
            <h5 class="title is-2 custom-h5">
              Conciergo helps hotels create a unique and personalized experienced for their guests.
            </h5>
          </div>
          <div class="column hero-img is-6">
            <img :src="images.hero" alt="">
          </div>
        </div>
          <div class="column lm">
            <span class="learn-more has-text-black">Learn more <img :src="images.mouse" width="20" style="margin-bottom: -20px;"/></span>
          </div>
       </div>
    </section>

    <section>
      <div class="cotainer" :style="{ 'background-image': 'url(' + images.mapBg + ')' }" style="background-size: contain; background-position: center center;">
        <div class="services-solutions">
          <h1 class="title is-1 custom-h1 has-text-weight-bold" style="color: #fff;">Guest Service Solutions</h1>
          <h5 class="title is-3 custom-h5" style="color: #fff;">The 3-Step Guest Engagement System</h5>
        </div>
        <div class="container three-boxes">
          <div class="columns">
            <div class="column">
              <div class="card">
                <div class="card-content">
                  <div class="content">
                    <div class="columns is-mobile">
                      <div class="column is-one-fifth" style="padding-right: 0px;">
                        <h4 class="title is-3 has-text-weight-bold">01</h4>
                      </div>
                      <div class="column">
                        <h4 class="title is-3 has-text-weight-bold margin-remove has-text-danger">Digital</h4>
                        <h4 class="title is-3 margin-remove has-text-danger">Concierge</h4>
                      </div>
                    </div>
                    <p>
                      Conciergo is a Digital Concierge experience provides your guest with local and relevant information for your area creating more front desk efficiencies and leaving your guests satisfied.
                    </p>
                    <!-- <div class="has-text-right">
                      <span class="fa fa-plus has-text-danger"></span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <div class="card-content">
                  <div class="content">
                    <div class="columns is-mobile">
                      <div class="column is-one-fifth" style="padding-right: 0px;">
                        <h4 class="title is-3 has-text-weight-bold">02</h4>
                      </div>
                      <div class="column">
                        <h4 class="title is-3 has-text-weight-bold margin-remove has-text-danger">SMS</h4>
                        <h4 class="title is-3 margin-remove has-text-danger">Interface</h4>
                      </div>
                    </div>
                    <p>
                     Our new SMS Interface allows your guests to interact with your front desk staff with ease. 
                    </p>
                    <!-- <div class="has-text-right">
                      <span class="fa fa-plus has-text-danger"></span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <div class="card-content">
                  <div class="content">
                    <div class="columns is-mobile">
                      <div class="column is-one-fifth" style="padding-right: 0px;">
                        <h4 class="title is-3 has-text-weight-bold">03</h4>
                      </div>
                      <div class="column">
                        <h4 class="title is-3 has-text-weight-bold margin-remove has-text-danger">Reputation</h4>
                        <h4 class="title is-3 margin-remove has-text-danger">Capture</h4>
                      </div>
                    </div>
                    <p>
                      Welcome to the future of reputation management. Let us help you capture your guest reviews before they hit the public eyes! You’ll be happy you did.
                    </p>
                    <!-- <div class="has-text-right">
                      <span class="fa fa-plus has-text-danger"></span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container map-bg">
          <div class="columns">
            <div class="column is-half">
              <h5 class="title is-2 has-text-weight-bold margin-remove">Over 3,000 Hotels</h5>
              <!-- <div style="text-align: center"> -->
              <div>
                <h5 class="title is-2 margin-remove custom-h5">are benefitting from using our platform to elevate their guests experience and retention.</h5>
              </div>
              <br />
              <a href="https://conciergo.com/_/upload/mediakit/guest-engagement-solutions.pdf" class="button is-danger" target="_blank">
              View Media Deck
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="columns s-4" style="width: 100%; margin: 0px;">
        <div class="column" style="background: #af1a4e; padding: 40px !important;">
          <img :src="images.lightbulb" alt="" width="60" style="filter: brightness(0) invert(1);">
          <p class="s-4-title"><strong class="has-text-white">Free up your front desk!</strong></p>
          <p class="has-text-white">Answer your customers' questions more efficiently and directly from your branded hotel Website.</p>
        </div>
        <div class="column" style="background: #065fc8; padding: 40px !important;">
          <img :src="images.garageWrenches" alt="" width="60" style="filter: brightness(0) invert(1);">
          <p class="s-4-title"><strong class="has-text-white">We make it easy!</strong></p>
          <p class="has-text-white">Conciergo will create a personal experience for your guests and link to your website, front desk, or reservations system.</p>
        </div>
        <div class="column" style="background: #67c7c7; padding: 40px !important;">
          <img :src="images.piggyBank" alt="" width="60" style="filter: brightness(0) invert(1);">
          <p class="s-4-title"><strong class="has-text-white">Conciergo is very vast effective!</strong></p>
          <p class="has-text-white">Our platform is fast and inexpensive to deploy and create ROI for your business. It doesn’t get any better!</p>
        </div>
        <div class="column" style="background: #d02032; padding: 40px !important;">
          <img :src="images.partnersClaping" alt="" width="60" style="filter: brightness(0) invert(1);">
          <p class="s-4-title"><strong class="has-text-white">Create happy guests!</strong></p>
          <p class="has-text-white">Increase customer retention, social engagement, and receive great reviews.</p>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="portfolio">
            <h1 class="title is-1 custom-h1 has-text-danger" style="font-weight: bold;">Our Portfolio</h1>
            <h5 class="title is-3 custom-h5">Meet some of our friends.</h5>
        </div>
        <div class="columns is-mobile is-multiline is-centered hotels">
          <div class="column is-one-quarter-desktop is-half-mobile is-half-tablet is-narrow" v-for="pf in portfolios" style="text-align: center;" :key="pf">
            <img :src="pf" width="70%" style="vertical-align: middle;">
          </div>
        </div>
      </div>
    </section>

    <section class="testimonials">
      <div id="example">
        <carousel-3d :autoplay="true" :autoplay-timeout="5000" :display="3" :space="500" :border="0" :scaling="500" :controls-visible="true">
          <slide v-for="(slide, i) in slides" :index="i" :key="i">
            <div class="card p-40">
              <h5 class="title is-4 custom-h5 has-text-danger">"{{ slide.review }}"</h5>
                <h5 class="title is-4 has-text-weight-bold mb-10"><strong>{{ slide.name}}</strong></h5>
                <h5 class="title is-4 has-text-weight-normal"><strong>{{ slide.title}}</strong></h5>
            </div>
          </slide>
        </carousel-3d>
      </div>      
    </section>

    <page-footer></page-footer>
  </div>
</template>
<script>
import hero from './../assets/images/hero/device-img.png';
import lightbulb from './../assets/images/icons/lightbulb.svg';
import garageWrenches from './../assets/images/icons/garage-wrenches.svg';
import piggyBank from './../assets/images/icons/piggy-bank.svg';
import partnersClaping from './../assets/images/icons/partners-claping-hands.svg';
import ramada from './../assets/images/hotels/ramada-logo.png';
import howardJohnson from './../assets/images/hotels/howard johnson-logo.png';
import bestWestern from './../assets/images/hotels/best-western-logo.png';
import bestValueInn from './../assets/images/hotels/American-Best-Value-Inn-logo.png';
import wynDham from './../assets/images/hotels/Wyndham-logo.png';
import one from './../assets/images/hotels/hotel-32one-logo.png';
import choice from './../assets/images/hotels/choice-logo.png';
import daysInn from './../assets/images/hotels/days-inn-logo.png';
import laQuinta from './../assets/images/hotels/la-quinta-logo.png';
import blvd from './../assets/images/hotels/blvd-logo.png';
import comfortInn from './../assets/images/hotels/Comfort-inn-logo.png';
import motel6 from './../assets/images/hotels/motel-6-logo.png';
import mapBg from './../assets/images/hero/map.png';
import mouse from './../assets/images/icons/mouse-icon.svg';
export default {
  data() {
    return {
      slides: [
        {
          name: 'David Chin',
          title: 'CEO + President of Personality Hotels',
          review: 'Conciergo has changed my hotel operations in the best way possible.'
        },
        {
          name: 'Vijay Patel',
          title: 'Owner, Van Ness Inn San Francisco',
          review: 'The reputation capture program is godsend. A must have!'
        },
        {
          name: 'Kiran Thakor',
          title: 'Owner, Multiple Hotels',
          review: 'My staff is extremely satisfied with our new services allowing them to focus on other tasks.'
        }
      ],
      images: {
        hero,
        lightbulb,
        garageWrenches,
        piggyBank,
        partnersClaping,
        mapBg,
        mouse
      },
      portfolios: [
        ramada,
        howardJohnson,
        bestWestern,
        bestValueInn,
        wynDham,
        one,
        choice,
        daysInn,
        laQuinta,
        blvd,
        comfortInn,
        motel6
      ]
    }
  },
  mounted() {
    var TxtRotate = function (el, toRotate, period) {
      this.toRotate = toRotate;
      this.el = el;
      this.loopNum = 0;
      this.period = parseInt(period, 10) || 2000;
      this.txt = '';
      this.tick();
      this.isDeleting = false;
    };

    TxtRotate.prototype.tick = function () {
      var i = this.loopNum % this.toRotate.length;
      var fullTxt = this.toRotate[i];

      if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
      } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
      }

      this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>';

      var that = this;
      var delta = 300 - Math.random() * 100;

      if (this.isDeleting) {
        delta /= 2;
      }

      if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
      } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
      }

      setTimeout(function () {
        that.tick();
      }, delta);
    };

    window.onload = function () {
      var elements = document.getElementsByClassName('txt-rotate');
      for (var i = 0; i < elements.length; i++) {
        var toRotate = elements[i].getAttribute('data-rotate');
        var period = elements[i].getAttribute('data-period');
        if (toRotate) {
          new TxtRotate(elements[i], JSON.parse(toRotate), period);
        }
      }
      // INJECT CSS
      var css = document.createElement("style");
      css.type = "text/css";
      css.innerHTML = ".txt-rotate > .wrap { border-right: 0.08em solid #666 }";
      document.body.appendChild(css);
    };
  }
}
</script>
<style scoped lang="scss">
.testimonials {
  background: rgb(240, 239, 239); 
  padding: 50px 0 50px 0;
}
#home-hero {
  padding: 30px; 
}
.custom-h1 {
  font-size: 4rem !important;
  margin-bottom: 0px !important;
}
.custom-h5 {
  font-weight: normal !important;
}
.learn-more {
  font-size: 30px;
  margin: -10px 0 0 85px;
}
.s-4 > div.column {
  padding: 50px !important;
  text-align: center;
}
.s-4-title {
  margin: 15px 0 15px 0;
}
.hotels {
  margin: 50px !important;
}
.margin-remove {
  margin: 0px !important;
}
.lm {
  margin-top: -50px;
  margin-bottom: 50px;
}
.hero-img {
  padding: 50px 0 0 0;
}
.services-solutions {
  padding: 30px 140px 180px 140px; 
  background: #001540;
}
.three-boxes {
  margin-top: -150px; padding: 0 30px 0 30px;
  .card{
    height: 100%;
  }
}
.map-bg {
  padding: 150px 0 100px 0;
}
.portfolio {
  margin: 60px 100px 0 100px;
}
@media only screen and (max-width: 425px) {
  .we-connect {
    padding: 25px;
    h1 {
      font-size: 35px !important;
    }
    h5 {
      font-size: 20px !important;
    }
  }
  .testimonials {
    padding: 5px 18px 5px 18px;
    padding: 0px;
    
    // .card {
    //   padding: 60px 30px 50px 30px;
    //   height: 100%;
    // }
    .carousel-3d-container {
      border-top: 1px solid #e6e4e4;
      border-bottom: 1px solid #e6e4e4;
      
    }
    div {
      .carousel-3d-slider {
        margin: 0px !important;
      }
    }
    h5 {
      font-size: 20px;
    }
  }
  .hotels {
    margin: 10px !important;
  }
  .portfolio {
    margin: 40px 30px 30px 30px;
    h1 {
      font-size: 35px !important;
    }
    h5 {
      font-size: 20px !important;
    }
  }
  .map-bg {
    padding: 30px;
    text-align: center;
    h5 {
      font-size: 20px;
    }
  }
  .home-hero {
    padding: 40px 40px 15px 40px;
    h1 {
      font-size: 35px !important;
    }
    h5 {
      font-size: 20px !important;
    }
  }
  .lm {
    margin: 0 0 20px 0;
    text-align: center;
    a {
      font-size: 20px;
    }
  }
  .learn-more {
    margin: 0 0 0 0 !important;
  }
  .services-solutions {
    padding: 30px;
    padding-bottom: 140px;
    h1 {
      font-size: 35px !important;
    }
    h5 {
      font-size: 20px !important;
      margin-top: 10px;
    }
  }
  .three-boxes {
    margin-top: -130px;
    .is-mobile {
      margin-bottom: 0px;
      h4 {
        font-size: 25px;
      }
      h4.has-text-danger {
        font-size: 18px;
      }
      p {
        font-size: 12px !important;
      }
    }
    p {
      font-size: 12px;
      margin-bottom: 0px !important;
    }
  }
}
</style>

